export const App = {
  MOTIVE_END_CLOSED: [
    'DE',
    'LA',
    'LE',
    'LG',
    'MU',
    'RT',
    'RU',
    '30',
    '31',
    '32',
    '33',
    '34',
    '36',
    '37',
    '38',
    '39',
    '40',
    '41',
    '66',
    '81',
    '84',
  ],
  MOTIVE_END_CANCELLED: [
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12',
  ],
};
